// reCAPTCHA Enterprise (score-based, invisible). The site key is an Enterprise
// score key, loaded once by public/index.html (enterprise.js?render=<key>), so it
// can't drive a v2 checkbox widget: that shows "ERROR for site owner: Invalid key
// type". Ask for a token at submit time instead. Returns null when the key is unset
// or the script is unavailable, so a blocked Google script never blocks sign-in.
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

export async function recaptchaToken(action) {
  if (!SITE_KEY || typeof window === 'undefined' || !window.grecaptcha?.enterprise) return null;
  try {
    await new Promise((resolve) => window.grecaptcha.enterprise.ready(resolve));
    return await window.grecaptcha.enterprise.execute(SITE_KEY, { action });
  } catch (e) {
    console.warn('reCAPTCHA unavailable:', e);
    return null;
  }
}
